// extracted by mini-css-extract-plugin
export default {"iconHeader":"ModalPesquisar_iconHeader__Dk6q2","form":"ModalPesquisar_form__wg9E2"};